import { FileExcludeRule } from './plan-file-exclude-rule-model';

export class VolumeInfoBackupOptions {
  public UseVss: boolean;
  public ExcludeRules: FileExcludeRule[];
  public KeepBitLocker: boolean;
}
